<template>
  <div>
    <section class="ra-section newsletter dark">
      <div class="inner">
        <div class="grid">
          <div class="subject">Get updates</div>
          <div class="field">
            <input
              id="ra-email"
              type="email"
              placeholder="Your email address"
              name="email"
              :class="{ error: errors.has('email') }"
              v-model="email"
              v-validate="{
                required: true,
                email: true,
                newsletterCheckEmail: true,
              }"
            />
            <span class="wwf-alert">
              <p v-if="errors.has('email')">{{ errors.first("email") }}</p>
            </span>
            <button
              id="ra-newsletter-button"
              type="button"
              v-on:click="emailSubmit"
            >
              <span v-if="!isLoading">Subscribe</span>
              <span v-if="isLoading">
                <i class="far fa-spinner-third fa-spin"></i>
              </span>
            </button>
          </div>
          <div class="spacer"></div>
          <div class="text">
            Subscribe to the WWF newsletter and stay up-to-date with the latest
            news on WWF’s work.
          </div>
        </div>
      </div>
    </section>

    <NewsletterDetails
      :email="email"
      :showModal="showModal"
      @closeModal="closeModal"
      v-if="showModal"
    ></NewsletterDetails>
  </div>
</template>

<script>
import NewsletterDetails from "./Details.vue";

import { Validator } from "vee-validate";
import { resizeIframe } from '../../helpers';

export default {
  name: "Newsletter",
  components: {
    NewsletterDetails,
  },

  data: () => {
    return {
      email: null,
      showModal: false,
      timeout: null,
      lastTimestamp: Date.now(),
      checkEmailLoading: false,
      emailRegex: /.+\@.+\..+/,
      isLoading: false,
      isLoadingConfirm: false,
    };
  },

  created() {
    const newsletterCheckEmail = (email) => {
      if (email.length > 0 && this.emailRegex.test(email)) {
        return new Promise((resolve, reject) => {
          let timestamp = Date.now(); // timestamp for this api call
          this.lastTimestamp = timestamp; // 1 , 2 , 3
          this.checkEmailLoading = true;
          // Fetch Suggestions
          this.$store
            .dispatch("validateEmail", email)
            .then((response) => {
              if (response && timestamp >= this.lastTimestamp) {
                this.checkEmailLoading = false;
                resolve(response);
              }
            })
            .catch((err) => {
              console.error(err);
              this.checkEmailLoading = false;
              // If the call failed, do not keep the user from donating
              resolve({
                valid: true,
              });
            });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" },
        };
      }
    };

    Validator.extend("newsletterCheckEmail", {
      validate: newsletterCheckEmail,
      getMessage: (field, params, data) => data.message,
    });
  },
  methods: {
    emailSubmit() {
      this.isLoading = true;
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.showModal = true;
          resizeIframe();
        }

        this.isLoading = false;
      });
    },
    closeModal() {
      this.showModal = false;
      this.isLoading = false;
      resizeIframe();

      // Reset form
      this.email = null;
    },
  },
};
</script>

<style scoped>
button {
  height: 48px;
  padding: 0 calc(3 * var(--space));
  padding-bottom: calc(0.5 * var(--space));
  font-family: var(--font-secondary);
  font-size: 1.5em;
  text-transform: uppercase;
  color: #fff;
  background-color: var(--orange);
  border-radius: var(--border-radius);
  cursor: pointer;
}

input {
  margin-bottom: 0;
  height: 48px;
  font-size: 16px;
}

button:hover,
button:focus {
  background-color: var(--orange);
}

@media screen and (min-width: 1024px) {
  button {
    padding: 0 calc(1.5 * var(--space));
    padding-bottom: calc(0.25 * var(--space));
    font-size: 1.2em;
  }
}

/* NEWSLETTER */

section.newsletter {
  margin-bottom: calc(3 * var(--space));
}

section.newsletter .subject {
  display: none;
  grid-column: span 2;
  align-self: center;
  margin-top: calc(-0.3 * var(--space));
  font-family: var(--font-secondary);
  font-size: 2em;
  line-height: 100%;
  white-space: nowrap;
  text-transform: uppercase;
  color: #fff;
}

section.newsletter .field {
  grid-column: span 6;
  align-self: center;
  display: flex;
}

section.newsletter .field input {
  border: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

section.newsletter .field input.error {
  border: 3px solid var(--wwfRed);
  box-shadow: unset;
}

section.newsletter .field button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

section.newsletter .text {
  grid-column: span 4;
  display: flex;
  align-items: center;
  width: 100%;
  color: #fff;
  font-size: 1em;
}

section.newsletter span.wwf-alert {
  width: auto;
}

@media screen and (max-width: 767px) {
  section.newsletter .grid {
    gap: calc(3 * var(--space));
    padding: calc(4 * var(--space)) calc(2 * var(--space));
  }

  section.newsletter .grid > div {
    grid-column: span 12;
    text-align: center;
  }

  section.newsletter .subject {
    display: block;
    font-size: 53px;
  }

  section.newsletter .field {
    flex-direction: column;
    gap: var(--space);
  }

  section.newsletter .text {
    justify-content: center;
  }
}

@media screen and (min-width: 1100px) {
  section.newsletter .subject {
    display: block;
  }

  section.newsletter .field {
    grid-column: span 4;
  }
}

/* From elcom, integrated for Makers-tech */
.text {
  font-family: 'Open Sans';
}

section.ra-section.dark {
  padding: calc(4 * var(--space)) 0;
  background-color: var(--black);
}

section.ra-section {
  width: calc(100% - 2 * var(--space));
  margin: var(--space);
  margin-top: calc(5 * var(--space));
}

.newsletter {
  position: relative;
}

section.ra-section .grid {
  display: grid;
  grid-template-columns: repeat(12,1fr);
  min-height:70px;
}

section.ra-section .inner {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

@media screen and (min-width: 768px) { 
  section.ra-section .inner {
    width: 87%;
  }
}

/* END */
</style>


// WEBPACK FOOTER //
// Newsletter.vue?c756d978